import React from 'react';

const UserAvatar = () => {
  return (
    <svg
      version='1.1'
      id='Ebene_1'
      x='0px'
      y='0px'
      width='24px'
      height='24px'
      viewBox='0 0 94 94'
      enableBackground='new 0 0 94 94'
      xmlSpace='preserve'
    >
      <path
        fill='#FFFFFF'
        d='M47.225,6.443c-22.648,0-41.017,18.359-41.017,41.017c0,22.658,18.359,41.018,41.017,41.018
S88.232,70.108,88.232,47.45C88.232,24.792,69.873,6.443,47.225,6.443z M47.225,12.318c19.378,0,35.142,15.765,35.142,35.142
c0,5.896-1.469,11.456-4.043,16.343c-5.67-1.205-18.84-4.005-20.622-4.328c-0.646-0.137-1.233-0.5-1.439-0.891
c-0.489-0.94,0.499-2.742,1.332-4.26c2.33-4.27,5.102-10.82,5.003-17.811c-0.059-4.759-1.948-9.263-5.17-12.347
c-2.947-2.82-6.678-4.22-10.829-4.113c-8.705,0.265-15.158,7.647-15.011,17.165c0.088,5.62,1.968,11.877,5.307,17.635
c1.126,1.908,1.283,3.152,1.058,3.672c-0.255,0.577-1.214,0.891-1.42,0.939l0,0c-1.577,0.284-14.315,3.143-20.308,4.484
c-2.634-4.925-4.132-10.535-4.132-16.499C12.083,28.083,27.848,12.318,47.225,12.318z'
      />
    </svg>
  );
};

export default UserAvatar;
